<!------------------------------------------------------------------------------
 File: BaseCodeInput 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-03-07
 Time: 14:40
------------------------------------------------------------------------------->
<template>
    <!-- Default input -->
    <div class="form-row align-items-center">
        <div class="col-12"
             :class="col_input">
            <input :maxlength="max_char"
                   :name="field"
                   :placeholder="(placeholder)?placeholder:''"
                   :autocomplete="autocomplete"
                   class="code form-control border py-2 my-1 text-center text-uppercase"
                   :class="{
                    'is-invalid':error
                   }"
                   type="text"
                   v-model="input.value"
                   :tabindex="tabindex"
                   v-tooltips-enabled="{
                        active:tooltip,
                        title:title
                    }"
            >
        </div>

        <div class="col-12 row no-gutters align-items-center"
             :class="col_btn_wrapper">
            <template>
                <BaseButtonRound
                        v-if="this.input.value != ''"
                        v-on:click.native="codeExists()"
                        class="ml-0 my-0"
                        :btn_type="validate_state.not_yet?'btn-warning':validate_state.valid?'btn-alert':'btn-danger'"
                        type="div"
                        :small="false"
                        :tooltip="false"
                >
                    <template slot="content">
                        <transition name="zoom">
                            <i v-if="validate_state.not_yet"
                               class="material-icons"
                            >help</i>
                            <i v-else-if="validate_state.valid"
                               class="material-icons"
                            >done</i>
                            <i v-else="validate_state.not_valid"
                               class="material-icons"
                            >clear</i>
                        </transition>
                    </template>
                </BaseButtonRound>
            </template>
            <template v-if="show_refresh">
                <BaseButtonRound
                        v-on:click.native="fetchCodeGenerated()"
                        class="ml-0 my-0"
                        type="div"
                        :small="false"
                        :tooltip="false"
                >
                    <template slot="content">
                        <i class="material-icons">refresh</i>
                    </template>
                </BaseButtonRound>
            </template>
        </div>
    </div>
</template>

<script>
	import axios from 'axios';

	export default {
		name: "BaseCodeInput",
		components: {},
		props: {
			code_validate_url: {
				type: String
			},
			code_generate_url: {
				type: String
			},
			autocomplete: {
				type: String,
                default:'on'
			},
			col_input: {
				type: String
			},
			col_btn_wrapper: {
				type: String
			},
			col_refresh: {
				type: String
			},
			col_validate: {
				type: String
			},
			value: {
				type: String
			},
			placeholder: {
				type: String
			},
			field: {
				type: String
			},
			max_char: {
				type: Number,
				default: 10
			},
			title: {
				type: String
			},
			validate_text: {
				type: String,
				default: 'Validate'
			},
			tooltip: {
				type: Boolean,
				default: true
			},
			tabindex: {
				type: Number,
				default: 0
			},
			error: {
				type: Boolean,
				default: false
			},
			identifier: {
				type: String,
				default: ''
			},
            
		},
		created() {
			if (this.value != '') {
				this.input.value = this.input.previous = this.value;
				this.show_refresh = false;
				this.setValidState('valid');
			}
			else {
				this.setValidState('not_yet');
			}
			if (typeof title !== 'undefined' && title !== null) {
				window.$(this.$el).find(`data-toggle='tooltip'`).tooltip();
			}
		},
		destroyed() {
		},
		mounted() {
			this.$nextTick(function () {
this.initialised = true;
			});
		},
		data() {
			return {
				initialised:false,
				input: {
					value: '',
					previous: ''
				},
				show_refresh: true,

				validate_state: {
					not_yet: true,
					valid: false,
					not_valid: false,
				}
			}
		},
		methods: {
			setValidState(the_state) {
				switch (the_state) {
					case 'not_valid':
						this.validate_state.not_yet = false;
						this.validate_state.valid = false;
						this.validate_state.not_valid = true;
						this.$emit('state_valid',false);
						this.$emit('form_error', {
							id: this.identifier,
							value: true
						});
						break;
					case 'valid':
						this.validate_state.not_yet = false;
						this.validate_state.valid = true;
						this.validate_state.not_valid = false;
						this.$emit('state_valid',true);
						this.$emit('form_error', {
							id: this.identifier,
							value: false
						});
						break;
					// not_yet as default
					default:
						this.validate_state.not_yet = true;
						this.validate_state.valid = false;
						this.validate_state.not_valid = false;
						this.$emit('state_valid',false);
						this.$emit('form_error', {
							id: this.identifier,
							value: false
						});
				}
			},
			codeExists() {
				if (this.validate_state.valid) {

					return;
				}

				let data = {
						code: this.input.value
					},
					url = this.code_validate_url;

				axios
					.post(url, data)
					.then(r => r.data)
					.then(response => {
						if (response != true) {
							this.input.value = this.input.previous = data.code;
							this.setValidState('valid');
							// send result to the parent
							this.$emit('input_value',data.code);

						}else{
							this.setValidState('not_valid');
                        }
						return response;
					})
					.catch(error => {
						this.setValidState('not_valid');
					});
			},
			fetchCodeGenerated() {
				let data = {
						length: this.max_char
					},
					url = this.code_generate_url;

				axios
					.post(url, data)
					.then(r => r.data)
					.then(response => {
						this.input.value = this.input.previous = response.code;
						this.setValidState('not_yet');
					})
					.catch(error => {
						console.error('error', error);
					});
			},
		},
		watch: {
			'input.value': function (value,oldValue) {
				if(this.initialised){
					this.input.value = value;
					if (this.error) {
						this.$emit('form_error', {
							id: this.identifier,
							value: false
						});
					}
					this.setValidState('not_yet');
					console.log('not_yet',value);
                }
			}
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseCodeInput.vue?131d9316